class ContactFormComponent extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    this.fields = Array.from(
      this.form.querySelectorAll('[data-contact-field]')
    );
    this.submitButton = this.form.querySelector('button[type="submit"]');

    this.onInput = this.onInput.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onInvalid = this.onInvalid.bind(this);

    this.form.addEventListener('input', this.onInput);
    this.form.addEventListener('submit', this.onSubmit);
    this.fields.forEach((field) => field.addEventListener('invalid', this.onInvalid));

    this.updateSubmitState();
  }

  disconnectedCallback() {
    this.form?.removeEventListener('input', this.onInput);
    this.form?.removeEventListener('submit', this.onSubmit);
    this.fields?.forEach((field) => field.removeEventListener('invalid', this.onInvalid));
  }

  getErrorEl(field) {
    const key = field.getAttribute('data-contact-field');
    return this.form.querySelector(`[data-contact-error="${key}"]`);
  }

  allFieldsEmpty() {
    return this.fields.every((field) => field.value.trim() === '');
  }

  updateSubmitState() {
    if (!this.submitButton) return;
    this.submitButton.disabled = this.allFieldsEmpty();
  }

  showFieldError(field) {
    const error = this.getErrorEl(field);
    if (error) error.hidden = false;
    field.setAttribute('aria-invalid', 'true');
  }

  clearFieldError(field) {
    const error = this.getErrorEl(field);
    if (error) error.hidden = true;
    field.removeAttribute('aria-invalid');
    field.setCustomValidity('');
  }

  isFieldValid(field) {
    const value = field.value.trim();
    if (value === '') return false;

    field.setCustomValidity('');

    if (field.type === 'email') {
      return !field.validity.typeMismatch;
    }

    if (field.hasAttribute('pattern')) {
      const pattern = field.getAttribute('pattern');
      return new RegExp(`^(?:${pattern})$`).test(value);
    }

    return true;
  }

  onInput(event) {
    const field = event.target.closest('[data-contact-field]') || event.target;
    this.updateSubmitState();

    if (field.matches?.('[data-contact-field]') && this.isFieldValid(field)) {
      this.clearFieldError(field);
    }
  }

  onInvalid(event) {
    event.preventDefault();
    const field = event.target;
    const error = this.getErrorEl(field);
    field.setCustomValidity(error?.textContent?.trim() || 'This field is required');
    this.showFieldError(field);
  }

  onSubmit(event) {
    let firstInvalid = null;

    this.fields.forEach((field) => {
      const value = field.value.trim();

      if (value === '') {
        field.value = '';
        const error = this.getErrorEl(field);
        field.setCustomValidity(error?.textContent?.trim() || 'This field is required');
        this.showFieldError(field);
        firstInvalid ||= field;
        return;
      }

      if (!this.isFieldValid(field)) {
        const error = this.getErrorEl(field);
        field.setCustomValidity(error?.textContent?.trim() || 'Please enter a valid value');
        this.showFieldError(field);
        firstInvalid ||= field;
        return;
      }

      this.clearFieldError(field);
    });

    if (firstInvalid) {
      event.preventDefault();
      firstInvalid.focus();
      firstInvalid.reportValidity();
    }
  }
}

if (!customElements.get('contact-form-component')) {
  customElements.define('contact-form-component', ContactFormComponent);
}
